module.exports = __webpack_public_path__ + "static/img/ibs-fm-management.eb2308a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/ibs-fm-management.jpg
// module id = HfFj
// module chunks = 0